function clearStoredUser() {
  try {
    localStorage.removeItem('user');
  } catch {
    // Ignore storage failures during auth recovery.
  }
}

function redirectToLogin() {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.pathname.startsWith('/login')) {
    return;
  }

  window.location.assign('/login');
}

function handleUnauthorizedResponse(status) {
  if (status !== 401 && status !== 403) {
    return;
  }

  clearStoredUser();
  redirectToLogin();
}

export async function fetchAuthenticated(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'include',
    ...options,
  });

  handleUnauthorizedResponse(response.status);
  return response;
}

export async function fetchAuthenticatedJson(url, options = {}) {
  const response = await fetchAuthenticated(url, options);
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : await response.text();

  if (!response.ok) {
    throw new Error(payload?.message || payload || `HTTP ${response.status}`);
  }

  return payload;
}